export enum UserRoles {
    SUPER_ADMIN = 'SUPER_ADMIN',
    UNDEFINED = 'UNDEFINED',
    ANNUAL_REPORTS_USER = 'AnnualReportUser',
}
